module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form class="form" id="' +
((__t = (id)) == null ? '' : __t) +
'">\n    <div class="form-group row">\n        <label class="DescartesUILabel">' +
((__t = (labelAdresseMessage)) == null ? '' : __t) +
'</label>\n        <input type="text" class="DescartesUIInput form-control" id="' +
((__t = (id)) == null ? '' : __t) +
'_choosedAdresse" name="choosedAdresse">\n    </div>\n    <div class="form-group row">\n        <label class="DescartesUILabel">' +
((__t = (labelCommuneMessage)) == null ? '' : __t) +
'</label>\n        <input type="text" required="true" class="DescartesUIInput form-control" id="' +
((__t = (id)) == null ? '' : __t) +
'_choosedCommune" name="choosedCommune">\n    </div>\n    <button type="submit" class="DescartesUIButtonSubmit btn ' +
((__t = (btnCssSubmit)) == null ? '' : __t) +
'">' +
((__t = (buttonSearchMessage)) == null ? '' : __t) +
'</button>\n    <button id="' +
((__t = (id)) == null ? '' : __t) +
'_clear" class="DescartesUIButton btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'">' +
((__t = (buttonClearMessage)) == null ? '' : __t) +
'</button>\n</form>\n<br/>\n<div id="' +
((__t = (id)) == null ? '' : __t) +
'_wait" class="alert alert-info" style="display:none">' +
((__t = (waitMessage)) == null ? '' : __t) +
'</div>\n<div id="' +
((__t = (id)) == null ? '' : __t) +
'_result" class="alert alert-success" style="display:none">\n    <div class="list-group">\n\n    </div>\n</div>\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/LocalisationAdresseInPlace.ejs
// module id = 417
// module chunks = 0